import { z } from "zod";

export const patientStatusEnum = z.enum([
  "ACTIVE", // fully functional.  Active data will appear in all of your lists and reports.
  "ARCHIVED", // Still active, but hidden.  Putting things in the “archived” state is a way for you to shorten your lists.  Anything archived will not appear in invoicing/time tracking lists but they will appear under Reports
  "DECEASED",
]);

export type PatientStatus = z.infer<typeof patientStatusEnum>;
